// vue-loader at least v13.0.0+
module.exports = function (file) {
  try {
    return require('@/views/' + file + '.vue').default;
  } catch (e) {
    console.warn("[\u8DEF\u7531\u8B66\u544A] \u7EC4\u4EF6 \"".concat(file, "\" \u4E0D\u5B58\u5728\uFF0C\u4F7F\u7528\u5360\u4F4D\u9875\u9762\u66FF\u4EE3"));
    return require('@/views/common/NotFound.vue').default;
  }
};